const STRING = {
    TOKEN_NOT_VALID: 'token_not_valid',
    MY_PROFILE: 'My Profile',
    USER_MGMNT: 'User Management',
    HELP: 'Help',
    ALERTS: 'Alerts',
    HOME: 'Home',
    SEARCH_N_FILTER: 'Search & Filter',
    INSIGHTS: 'Insights',
    MY_KOGNETICS: 'My Kognetics',
    GLOBAL_SEARCH: 'Search Company, Investor, Person, Sector, Industry, Sub-Industry',
    COLUMNS: 'Manage Columns',
    EXPORT_CSV: 'Export to CSV',
    FILTER: 'Manage Filters',
    COMPANY: 'Company',
    COMPANIES: 'Companies',
    APOLLO_DATA: "Apollo Data",
    SECTOR: 'Sector',
    SECTORS: 'Sectors',
    INDUSTRY: 'Industry',
    INDUSTRIES: 'Industries',
    SUB_INDUSTRY: 'Sub-Industry',
    SUB_INDUSTRIES: 'Sub-Industries',
    ACQUISITION: 'Acquisition',
    ACQUISITIONS: 'Acquisitions',
    DEAL_IDEA: 'Deal Idea',
    DEAL_IDEAS: 'Deal Ideas',
    INVESTOR: 'Investor',
    INVESTORS: 'Investors',
    FUNDING_ROUND: 'Funding Round',
    FUNDING_ROUNDS: 'Funding Rounds',
    BUSINESS_SIGNAL: 'Business Signal',
    BUSINESS_SIGNALS: 'Business Signals',
    BUSINESS_SIGNALS_TREE: 'Tree Signals',
    STACK_VIEW: 'Stack View',
    ADD_TO_LIST: 'Add To List',
    SEARCH: 'Search',
    GRAPH_VIEW: 'Graph View',
    SIGNALS_SCORE: 'Signal Scores',
    TREE_MAP_VIEW: 'Tree Map View',
    SAVE: 'Save',
    MY_SAVED_SEARCH: 'My Saved Searches',
    MY_LIST: 'My List',
    MY_PREFERENCES: 'My Preferences',
    DELETE: 'Remove',
    ADD: 'Add Item',
    ALL: 'ALL',
    PROFILE: 'Profile',
    OVERVIEW: 'Overview',
    TOP_STRATEGICS: 'TopStrategics',
    TOP_INVESTOR: 'TopInvestors',
    GROWTH_COMANIES: 'GrowthCompanies',
    DUE_FOR_EXIT: 'DueForExitCompanies',
    SERIAL_FOUNDER: 'SerialFounders',
    SERIAL_BOARD_MEMBER: 'SerialBoardMember',
    NEWS_AND_SIGNAL: 'News & Signals',
    KEY_FINANCIALS: 'Key Financials',
    TEAM: 'Teams',
    COMING_SOON: 'Coming Soon',
    FOR_ENTERPRISE_TECH: 'For Companies In Enterprise Tech',
    FOR_ACROSS_INDUSTRIES: 'For Companies Across Industries',
    FOR_PROJECTS: "For Projects",
    COMPANY_CORPUS: "Company Text Corpus",
    COMPANY_NEWS_CORPUS: "Company News Corpus",
    COMPANY_NEWS_CORPUS_VECTOR: "Company News Corpus Semantic",
    PROJECT_1_TEXT_CORPUS: 'project1_text_corpus',
    PROJECT_2_TEXT_CORPUS: 'project2_text_corpus',
    PROJECT_3_TEXT_CORPUS: 'project3_text_corpus',
}

const ICONS = {
    MENU: 'fa-bars',
    USR_MGMNT: 'fa-users',
    HELP: 'fa-question-circle',
    ALERTS: 'fa-bell',
    HOME: 'fa-home',
    SEARCH: 'fa-search',
    INSIGHTS: 'fa-lightbulb-o',
    MY_KOGNETICS: 'fa-user-md',
    COLUMNS: 'fa-columns',
    TREE_MAP: 'fa-tree',
    SIGNALS_SCORE: 'fa-star',
    EXPORT_CSV: 'fa-download',
    FILTER: 'fa-filter',
    COMPANIES: 'fa-building-o',
    SECTOR: 'fa-industry',
    INVESTOR: 'fa-usd',
    FUNDING_ROUND: 'fa-money',
    ACQUISITIONS: 'fa-handshake-o',
    BUSINESS_SIGNALS: 'fa-signal',
    PLUS_CIRCLE: 'fa-plus-circle',
    GRAPH_VIEW: 'fa-bar-chart',
    SAVE: 'fa-save',
    MY_SAVED_SEARCH: 'fa-user-plus',
    MY_LIST: 'fa-list-alt',
    MY_PREFERENCES: 'fa-cogs',
    DELETE: 'fa-trash-o',
    ADD: 'fa-plus',
    PROFILE: 'fa-user',
    APOLLO_DATA: 'fa-database',
    TEXT_CORPUS: 'fa-file-text-o',
    NEWS_CORPUS: 'fa-newspaper-o'
}

const QUERY_PARAMS = {
    COMPANIES: 'company',
    SECTOR: 'sector',
    INDUSTRY: 'industry',
    SUB_INDUSTRY: 'subindustry',
    INVESTOR: 'investor',
    FUNDING_ROUND: 'fundingrounds',
    ACQUISITIONS: 'acquisitions',
    DEAL_IDEAS: 'dealideas',
    BUSINESS_SIGNAL: 'businesssignal',
    COMPANY_NEWS: 'companynews',
    APOLLO_DATA: 'apollodata',
    COMPANY_CORPUS: "company_text_corpus",
    COMPANY_NEWS_CORPUS: "company_news_corpus",
    COMPANY_NEWS_CORPUS_VECTOR: 'company_news_corpus_vector',
    PROJECT_1_TEXT_CORPUS: 'project1_text_corpus',
    PROJECT_2_TEXT_CORPUS: 'project2_text_corpus',
    PROJECT_3_TEXT_CORPUS: 'project3_text_corpus',
}

const SELECT_MENU_PROPS = {
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "left",
    }
}

const ENTITY = {
    [QUERY_PARAMS.COMPANIES]: 'Name',
    [QUERY_PARAMS.SECTOR]: 'Sector Name',
    [QUERY_PARAMS.INDUSTRY]: 'Industry Name',
    [QUERY_PARAMS.SUB_INDUSTRY]: 'Sub-Industry Name',
    [QUERY_PARAMS.INVESTOR]: 'Name',
    [QUERY_PARAMS.FUNDING_ROUND]: 'Company Name',
    [QUERY_PARAMS.ACQUISITIONS]: 'Acquirer Name',
    [QUERY_PARAMS.DEAL_IDEAS]: '',
    [QUERY_PARAMS.BUSINESS_SIGNAL]: 'Company Name',
    'Top Investors': 'InvestorName',
    'Similar Companies': 'Name',
    'Comparables': 'Name',
    'companyinvestors': 'Investor',
    'Top Strategics': 'Company',
    'Growth Companies': 'Name',
    'Due for Exit Companies': 'Name'
}

const ENTITY_POPUP_COLUMNS = ['Name', 'Sector Name', 'Industry Name', 'Sub-Industry Name',
    'Company Name', 'Target Name', 'Acquirer Name', 'Company', 'Investor Name', 'InvestorName']

const TOOLTIP_KEYWORDS = ['Description', 'Sector', 'Industry', 'Sub-Industry', 'Investor',
    'Potential Acquirer', 'Potential Target', 'Definition', 'Companies Due For Exit',
    'Growth Companies', 'Preferred Sector', 'Preferred Country', 'Acquirer Sector',
    'Acquirer Industry', 'Acquirer SubIndustry', 'Target Sector', 'Target Industry',
    'Target Sub-Industry', 'Target Investor', 'Acquirer Description', 'Target Description',
    'Company Description', 'Investor Description', 'Lead Investor Name', 'SubIndustry',
    'AcquiredCompanies', 'News Title', 'News Snippet', 'Overlapping Segments',
    'Acquisition Rationale', 'Portfolio Companies', 'SEO Description', 'Keywords', 'Text Content']

const WIDE_COLUMNS_WITHOUT_TOOL_TIP = ['Sector Name', 'Industry Name', 'Acquirer Name',
    'Sub-Industry Name', 'Name', 'Company Name', 'Investor Business Region', 'Target Name',
    'Relevant Acquirer Sector', 'Relevant Acquirer Industry', 'Relevant Acquirer Sub-Industry',]

const SORTING_KEYWORDS = ['Description', 'Sector', 'Industry', 'Sub-Industry', 'Investor',
    'Potential Acquirer', 'Potential Target', 'Definition', 'Companies Due For Exit',
    'Growth Companies', 'Preferred Sector', 'Preferred Country', 'Acquirer Sector',
    'Acquirer Industry', 'Acquirer SubIndustry', 'Target Sector', 'Target Industry',
    'Target SubIndustry', 'Target Investor', 'Acquirer Description', 'Target Description',
    'Company Description', 'Investor Description', 'Lead Investor Name', 'SubIndustry',
    'AcquiredCompanies', 'News Title', 'News Snippet']

const ALERTS = ['daily', 'weekly', 'monthly', 'never']

const SIGNALS = ['Growth Signals', 'Executive Signals', 'Risk Signals', 'ESG']
const GRAPHCOLOR = ['rgba(44, 63, 139, 0.9)', 'rgba(44, 63, 139, 0.8)',
    'rgba(44, 63, 139, 0.7)', 'rgba(44, 63, 139, 0.6)', 'rgba(44, 63, 139, 0.5)', 'rgba(44, 63, 139, 0.4)',
    'rgba(44, 63, 139, 0.3)', 'rgba(44, 63, 139, 0.2)']

const ALWAYS_IN_TABLE = ['Name', 'Sector Name', 'Industry Name', 'Sub-Industry Name',
    'Target Name', 'Acquirer Name', 'Announced Date',
    'Company Name', 'Business Signal', 'Date', 'News Title', 'News Snippet'
]

const dollarM = ['Valuation', 'Total Funding', 'Total Funding Amount', 'Total Funding (YTD)', 'Average Funding', 'Transaction Value', 'Money Raised']

const NOT_IN_TABLE = ['Permalink', 'PersonPermalink', 'InvestorPermalink', 'CompaniesPermalink', 'BoardMemberPermalink', 'SerialFounderPermalink', 'Similarity Score']

const VECTOR_SEARCH = ['News Snippet']

export {
    STRING, ICONS, ALERTS,
    SELECT_MENU_PROPS, SIGNALS,
    QUERY_PARAMS, GRAPHCOLOR,
    ENTITY, TOOLTIP_KEYWORDS,
    ENTITY_POPUP_COLUMNS,
    ALWAYS_IN_TABLE,
    dollarM, SORTING_KEYWORDS,
    NOT_IN_TABLE, VECTOR_SEARCH,
    WIDE_COLUMNS_WITHOUT_TOOL_TIP
}